<template>
  <component
    :is="getElementTag"
    :class="type === 'large-title' ? 'large-title' : null"
  >
    <slot>
      {{ text }}
    </slot>
  </component>
</template>

<script>
export default {
  name: 'MText',
  props: {
    /**
     * Set the typestyle of text
     * The options are:
     * page-title, stage-title, large-title, section, body, caption
     */
    type: {
      type: String,
      default: 'body',
    },
    /**
     * Set the content of the text
    */
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    getElementTag() {
      const mapping = {
        'page-title': 'h1',
        'stage-title': 'h2',
        'large-title': 'div',
        section: 'h3',
        body: 'p',
        caption: 'small',
      };
      return mapping[this.type] ? mapping[this.type] : 'p';
    },
  },
};
</script>
